import { CSSProperties } from 'react';

interface SvgTextProps {
  readonly fill: string;
  readonly stroke: string;
  readonly strokeWidth: string;
  readonly textAnchor: string;
  readonly fontSize: string;
}

const FONT_SIZE = '8px';
const STROKE_COLOR = '#cccccc';
const STROKE_WIDTH = '0.5';

export const svgTextStyles: SvgTextProps = {
  fill: 'currentColor',
  stroke: STROKE_COLOR,
  strokeWidth: STROKE_WIDTH,
  textAnchor: 'right',
  fontSize: FONT_SIZE,
} as const;

export const valueContainerStyles: CSSProperties = {
  fontSize: FONT_SIZE,
  color: 'currentColor',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '100%',
  paddingRight: '3em',
} as const;

export const deviceDataPointsSectionStyles = {
  svgText: svgTextStyles,
  valueContainer: valueContainerStyles,

  rect: {
    fill: 'transparent',
    stroke: STROKE_COLOR,
    strokeWidth: STROKE_WIDTH,
  } as const,

  foreignObject: {
    valueWidth: 80,
    valueHeight: 20,
    xOffset: 70,
    yOffset: -10,
    rowHeight: 15,
  } as const,

  layout: {
    labelYOffset: -20,
    rectPadding: 5,
    rectWidth: 155,
    rectBottomPadding: 10,
    rowSpacing: 15,
  } as const,
} as const;
